<template>
	<BaseCmsRotator 
		:fetch="{code: 'featured_promo_v2', limit: 16, response_fields: ['id','title','code','link_target_blank','url_without_domain','image_upload_path']}"
		@loadRotatorItems="loadRotatorItems"
		thumb-preset="promoFeaturedRotator"
		v-slot="{items}">
		<div class="slider-container" v-if="items?.length">
			<div class="wrapper slider-wrapper">
				<BaseUiSwiper
					name="featured-promo"
					:options="{
						breakpoints: {
							900: {
								slidesPerView: 4,
								slidesPerGroup: 4,
								spaceBetween: 24,
							},
							600: {
								slidesPerView: 2.4,
								slidesPerGroup: 2,
								spaceBetween: 12,
							},
							0: {
								slidesPerView: 1.4,
								slidesPerGroup: 1,
								spaceBetween: 12,
							}
						}
					}">
					<BaseUiSwiperSlide v-for="(item, index) in items" :key="item.id">
						<NuxtLink :target="item.link_target_blank == 1 ? '_blank' : null" :to="item.url_without_domain" class="featured-promo-slide" @click="gtmTrack('select_promotion', {
							creative_name: item.title || '',
							creative_slot: item.template + (index + 1),
							promotion_id: item.id || '',
							promotion_name: item.title || '',
						})">
							<div class="featured-promo-img">
								<BaseUiImage :loading="index < 2 ? 'eager' : 'lazy'" :data="item.image_upload_path_thumb" default="/images/no-image.jpg" :alt="item.title" />
							</div>
						</NuxtLink>
					</BaseUiSwiperSlide>
				</BaseUiSwiper>
			</div>
		</div>
	</BaseCmsRotator>
</template>

<script setup>
	const {gtmTrack} = useGtmBB();
	function loadRotatorItems(value) {
		if (value?.items?.length) {
			value.items.forEach((item, index) => {
				let template = '';
				if(item.template) template = item.template;
				gtmTrack('view_promotion', {
					creative_name: item.title || '',
					creative_slot: value.creativeSlot + template + (index + 1),
					promotion_id: item.id || '',
					promotion_name: item.title || '',
				});
			});
		}
	}
</script>

<style scoped lang="less">
	.slider-container{
		position: relative; margin-bottom: 50px;
		@media (max-width: @m){margin-bottom: 25px;}
		@media (max-width: 420px){height: 135px;}
		@media (max-width: 400px){height: auto;}
		:deep(.swiper){overflow: initial;}

		// page speed cls
		@media (max-width: 1360px){height: 153px;}
		@media (max-width: 1300px){height: auto;}
		@media (max-width: 420px){height: 134px;}
		@media (max-width: 400px){height: auto;}
	}
	:deep(.swiper-slide){
		width: auto; margin-right: 24px;
		@media (max-width: @m){margin-right: 12px;}
	}
	.featured-promo-img{
		display: flex; align-items: center; justify-content: center; border-radius: 12px;
		:deep(img){
			display: block; width: auto; height: auto; max-width: 100%; max-height: 100%; border-radius: 12px;
			@media (max-width: 420px){max-height: 140px;}
		}

		@media (max-width: @m){
			border-radius: 8px;
			:deep(img){border-radius: 8px;}
		}
	}
</style>